<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>

      <Sidebar></Sidebar>

      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Create Company</h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Subscription</label>
                      <div class="col-md-12 border-bottom p-0">
                        <select
                          multiple="true"
                          name="country"
                          v-model.trim="$v.subscription.$model"
                          :class="{'is-invalid': validationStatus($v.subscription)}"
                          class="form-control"
                        >
                          <option value="">Select Subscription</option>
                          <option
                            v-for="subscription in subscriptions"
                            v-bind:key="subscription.name"
                            v-bind:value="subscription.id"
                          >
                            {{ subscription.name }}
                          </option>
                        </select>
                        <div
                          v-if="!$v.subscription.required"
                          class="invalid-feedback"
                        >
                          The subscription field is required.
                        </div>
                        <!-- <span>Selected: {{ subscription }}</span>--->
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Category</label>
                      <div class="col-md-12 border-bottom p-0">
                        <select
                          multiple="true"
                          name="category"
                          v-model.trim="$v.category.$model"
                          :class="{'is-invalid': validationStatus($v.category)}"
                          class="form-control"
                        >
                          <option value="">Select category</option>
                          <option
                            v-for="category in categories"
                            v-bind:key="category.name"
                            v-bind:value="category.id"
                          >
                            {{ category.name }}
                          </option>
                        </select>
                        <div
                          v-if="!$v.category.required"
                          class="invalid-feedback"
                        >
                          The category field is required.
                        </div>
                        <!-- <span>Selected: {{ subscription }}</span>--->
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Name</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.name.$model"
                          :class="{'is-invalid': validationStatus($v.name)}"
                          class="form-control form-control-lg"
                        />
                        <div v-if="!$v.name.required" class="invalid-feedback">
                          The name field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Email</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.email.$model"
                          :class="{'is-invalid': validationStatus($v.email)}"
                          class="form-control form-control-lg"
                        />
                        <div v-if="!$v.email.required" class="invalid-feedback">
                          The Email field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">About</label>
                      <div class="col-md-12 border-bottom p-0">
                        <textarea
                          v-model.trim="$v.about.$model"
                          :class="{'is-invalid': validationStatus($v.about)}"
                          class="form-control form-control-lg"
                          rows="5"
                        ></textarea>
                        <div v-if="!$v.about.required" class="invalid-feedback">
                          The about field is required.
                        </div>
                      </div>
                    </div>
                    <!-- new code to Image (Logo) fire base -->
                           <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Logo</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImage"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValue.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValue"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageData!=null">
                          <img class="preview" :src="picture" />

                          <a    id= "bb" href="#" @click="onUpload">Upload</a>
                        </div>
                      </div>
                    </div>
                  </div>
                    <!-- end logo -->
                  <!-- company Background image firebase -->
                 <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Company Backgound Image</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input
                            type="file"
                            @change="previewImagech"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValuech.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValuech"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageDatach!=null">
                          <img class="preview" :src="picturech" />

                          <a  id= "bb" href="#"  @click="onUploadch">Upload</a>
                        </div>
                      </div>
                    </div>
                  </div>
                     
                   <!-- End company Background image firebase -->

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Location</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.location.$model"
                          :class="{'is-invalid': validationStatus($v.location)}"
                          class="form-control"
                        />
                        <div
                          v-if="!$v.location.required"
                          class="invalid-feedback"
                        >
                          The location field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Country</label>
                      <div class="col-md-12 border-bottom p-0">
                        <select
                          name="country"
                          v-model.trim="$v.country.$model"
                          :class="{'is-invalid': validationStatus($v.country)}"
                          class="form-control"
                        >
                          <option value="">Select Country</option>
                          <option
                            v-for="country in countries"
                            v-bind:key="country.name"
                            v-bind:value="country.id"
                          >
                            {{ country.name }}
                          </option>
                        </select>

                        <div
                          v-if="!$v.country.required"
                          class="invalid-feedback"
                        >
                          The country field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Postcode</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.postcode.$model"
                          :class="{'is-invalid': validationStatus($v.postcode)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.postcode.required"
                          class="invalid-feedback"
                        >
                          The postcode field is required.
                        </div>
                      </div>
                    </div>
                    <div class="main">
                      <div class="flex">
                        <!-- Map Display here -->
                        <div class="map-holder">
                          <div id="map"></div>
                        </div>

                        <!-- Coordinates Display here -->
                        <div class="dislpay-arena">
                          <div class="coordinates-header">
                            <h3>Current Coordinates</h3>
                            <p>Latitude: {{ center[0] }}</p>
                            <p>Longitude: {{ center[1] }}</p>
                          </div>

                          <div class="coordinates-header">
                            <h3>Current Location</h3>

                            <div class="form-group">
                              <input
                                type="text"
                                class="location-control"
                                :value="location"
                                readonly
                              />
                              <button
                                type="button"
                                class="copy-btn"
                                @click="copyLocation"
                              >
                                Copy
                              </button>
                            </div>

                            <button
                              type="button"
                              :disabled="loading"
                              :class="{ disabled: loading}"
                              class="location-btn"
                              @click="getLocation"
                            >
                              Get Location
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Phone No</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.phone_no.$model"
                          :class="{'is-invalid': validationStatus($v.phone_no)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.phone_no.required"
                          class="invalid-feedback"
                        >
                          The phone no field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Website URL</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.website.$model"
                          :class="{'is-invalid': validationStatus($v.website)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.website.required"
                          class="invalid-feedback"
                        >
                          The website field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Outlets included</label>
                      <div class="col-md-12 p-0 collapse-col">
                        <div
                          class="company-add"
                          v-for="(find, index) in finds"
                          :key="find.id"
                        >
                          <input
                            v-model="find.address"
                            class="form-control form-control-lg"
                            placeholder="Enter Address"
                          />
                          <input
                            v-model="find.city"
                            class="form-control form-control-lg"
                            placeholder="Enter City"
                          />
                          <span
                            class="
                              delete
                              btn
                              button-white
                              uppercase
                              fas
                              fa-times
                            "
                            @click="deleteFind(index)"
                          >
                          </span>
                        </div>

                        <span
                          id="add"
                          @click="addFind"
                          class="
                            btn
                            add-more
                            button-yellow
                            uppercase
                            fas
                            fa-plus
                          "
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Title</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.meta_title.$model"
                          :class="{'is-invalid': validationStatus($v.meta_title)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.meta_title.required"
                          class="invalid-feedback"
                        >
                          The meta title field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Description</label>
                      <div class="col-md-12 border-bottom p-0">
                        <textarea
                          v-model.trim="$v.meta_description.$model"
                          :class="{'is-invalid': validationStatus($v.meta_description)}"
                          class="form-control form-control-lg"
                          rows="5"
                        ></textarea>
                        <div
                          v-if="!$v.meta_description.required"
                          class="invalid-feedback"
                        >
                          The meta description field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Keywords</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.meta_keywords.$model"
                          :class="{'is-invalid': validationStatus($v.meta_keywords)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.meta_keywords.required"
                          class="invalid-feedback"
                        >
                          The meta keywords field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <div class="col-sm-12 pl-0 mt-10">
                        <input
                          type="submit"
                          class="btn btn-primary"
                          value="Submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  </body>
</template>

<script>

import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import mapboxgl from "mapbox-gl";
import axios from "axios";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import { db } from '../../main'
import firebase from 'firebase';

Vue.use(VueAxios,axios)

export default {
    name: 'Create',
    components:{
        'Header':Header,
        'Sidebar':Sidebar,
        'Footer':Footer,

    },
    data: function() {
        return {
      imageData: null,
			picture: null,
			uploadValue: 0,
  imageDatach: null,
			picturech: null,
			uploadValuech: 0,
	loading: false,
      locations: "",
      access_token: "pk.eyJ1IjoiaW50cm9zYnMiLCJhIjoiY2t2MHU4bWE4M2h1OTMwczcxMm03YmM0eSJ9.ocDaQEjuvL3rUd50oaB6Qw",
      center: [0, 0],
      map: {},
            name: '',
            email: '',
            asas: '',
            about: '',
           // image: '',
            background_image: '',
            location: '',
            country: '',
            maplocation:'',
            postcode: '',
            phone_no: '',
            lat: '',
            lang: '',
            website: '',
            meta_title: '',
            meta_description: '',
            meta_keywords: '',
            //previewImage:'',
            previewBackgroundImage:'',
            subscriptions: [],
            category: '',
            coordinates: [],
            categories:[],
            subscription:'',
            finds: [],
            countries: [],
        }
    },
 mounted() {
   
    this.createMap();
  },
    created: function(){
        this.getSubscriptions();
        this.getCountries();
        this.getCategory();
      

    },
    validations: {
        subscription: {required},
        name: {required},
        email: {required},
        about: {required},
        image: {},
        background_image: {},
        location: {required},
        country: {required},
        category: {required},
        postcode: {required},
        phone_no: {required},
        website: {required},
        meta_title: {},
        meta_description: {},
        meta_keywords: {}
    },

    methods: {

	previewImage(event) {
				this.uploadValue = 0;
				this.picture = null;
				this.imageData = event.target.files[0];
				console.log(this.imageData);
			},

		onUpload() {
				this.picture = null;
      // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageData.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
          }
          return result;
        }
				const storageRef = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageData);
				storageRef.on('state_changed', snapshot => {
					this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValue = 100;
					storageRef.snapshot.ref.getDownloadURL().then((url) => {
						this.picture = url;
            //alert(this.picture);
					});
				});
			},
			previewImagech(eventch) {
				this.uploadValuech = 0;
				this.picturech = null;
				this.imageDatach = eventch.target.files[0];
			},
			onUploadch() {
				this.picturech = null;
        // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageDatach.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         // eslint-disable-next-line no-unused-vars
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
          }
          return result;
        }
				const storageRefch = firebase.storage().ref(this.imagename+makeid(5)+"."+imageextension).put(this.imageDatach);
				storageRefch.on('state_changed', snapshot => {
					this.uploadValuech = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValuech = 100;
					storageRefch.snapshot.ref.getDownloadURL().then((url) => {
						this.picturech = url;
					});
				});
			},
	async createMap() {
      try {
       // alert(document.getElementsByClassName("mapboxgl-ctrl-geocoder--input"));
          
        mapboxgl.accessToken = this.access_token;
        this.map = new mapboxgl.Map({
          container: "map",
          style: "mapbox://styles/mapbox/streets-v11",
          center: this.center,
          zoom: 11,
        });
        let geocoder =  new MapboxGeocoder({
            accessToken: this.access_token,
            mapboxgl: mapboxgl,
            marker: false,
          });
        this.map.addControl(geocoder);
        geocoder.on("result", (e) => {
          const marker = new mapboxgl.Marker({
            draggable: true,
            color: "#D80739",
          })
            .setLngLat(e.result.center)
            .addTo(this.map);
          this.center = e.result.center;
          marker.on("dragend", (e) => {
            this.center = Object.values(e.target.getLngLat());
          });
        });
      } catch (err) {
        console.log("map error", err);
      }
    },
    async getLocation() {
      try {
        this.loading = true;
        const response = await axios.get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.center[0]},${this.center[1]}.json?access_token=${this.access_token}`
        );
        this.loading = false;
        this.locations = response.data.features[0].place_name;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    copyLocation() {
      if (this.locations) {
        navigator.clipboard.writeText(this.locations);
        alert("Location Copied")
      }
      return;
    },

        addFind: function () {
            this.finds.push({ address: '',city: '' });
          },
        deleteFind: function (index) {
        console.log(index);
        console.log(this.finds);
        this.finds.splice(index, 1);
        },

        getCountries()
        {
        this.countries = [];

            db.collection("countries")
            .get()
            .then((querySnapshot) => {
                //console.log('hhhh1');
                querySnapshot.forEach((doc) => {
                this.countries.push({
                    id: doc.id,
                    name: doc.data().country,
                    slug: doc.data().slug,
                });
                //console.log(doc.id, " => ", doc.data());

                });


            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
        },
        getCategory(){
 this.categories = [];

            db.collection("categories")
            .get()
            .then((querySnapshot) => {
                //console.log('hhhh1');
                querySnapshot.forEach((doc) => {
                this.categories.push({
                    id: doc.id,
                     name: doc.data().name,

                });
                //console.log(doc.id, " => ", doc.data());

                });


            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });

		},

        getSubscriptions()
        {
            this.subscriptions = [];

            db.collection("subscriptions")
              .get()
              .then((querySnapshot) => {
                console.log('hhhh1');
                querySnapshot.forEach((doc) => {
                  this.subscriptions.push({
                    id: doc.id,
                    name: doc.data().title,
                  });
                  //console.log(doc.id, " => ", doc.data());

                });

                console.log(this.subscriptions);
              })
              .catch((error) => {
                console.log("Error getting documents: ", error);
              });
        },


        validationStatus: function(validation) {
            return typeof validation != "undefined" ? validation.$error : false;
        },

        submit: function() {
           if(this.center[0] == ""){
             alert("Please select Location In the map");
             return false;
           }
           // alert(Math.floor(Math.random() * 10000));
             db.collection('countries').doc(this.country)
                .get().then(snapshot => {

      this.asas = snapshot.data().country;
 });

            this.$v.$touch();
            if (this.$v.$pendding || this.$v.$error) return;

            var  date = new Date().toLocaleString();//.toISOString().slice(0, 10);

  this.coordinates.push(this.center[0],this.center[1]);


					const stores =
 {
						'type': 'Feature',
						'geometry': {
			'type': 'Point',
 'coordinates': [this.center[0], this.center[1]]
						},
						'properties': {
  'phone': this.postcode,
				'company_name': this.name,
        'email':this.email,
         'website':this.website,
         'phone_no':this.phone_no,
 'address':this.location,
  'about': this.about,
 'logo': 	this.picture,
  'city': this.location,
					'country': this.asas,
					'postalCode': this.postcode,
						}
  }


            db.collection("companies")
            .add({
               
                subscription: this.subscription,
                category: this.category,
                name: this.name,
                email: this.email,
                code: Math.floor(Math.random() * 10000),
                about: this.about,
                image: 	this.picture,
                background_image: this.picturech,
                location: this.location,
                maplocation:this.locations,
                lat:this.center[0],
                lng:this.center[1],
                country: this.country,
                coordinates:  this.coordinates,
                postcode: this.postcode,
				stores:stores,
                phone_no: this.phone_no,
                website: this.website,
                outlets: this.finds,
                meta_title: this.meta_title,
                meta_description: this.meta_description,
                meta_keywords: this.meta_keywords,
                created: date,
                modified: date,
            })
            .then((doc) => {
                console.log("Added Successfully!");
                console.log(doc.id);

                db.collection("companies").doc(doc.id).update({ cid: doc.id });

          const stores =
{
						'type': 'Feature',
						'geometry': {
			'type': 'Point',
 'coordinates': [this.center[0], this.center[1]]
						},
						'properties': {
  'phone': this.postcode,
				'company_name': this.name,
        'email':this.email,
         'website':this.website,
         'phone_no':this.phone_no,
         'cid':doc.id,
 'address':this.location,
  'about': this.about,
 'logo': 	this.picture,
  'city': this.location,
					'country': this.asas,
					'postalCode': this.postcode,
						}
  }
  db.collection("companies").doc(doc.id).update({ stores: stores});
                

                this.$toasted.success('Success, Added Successfully!', {
                   icon : 'check',
                    //icon : 'error_outline'
                })
                this.$router.push('/companies/index');
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });

        }
    }
}
</script>
<style scoped>
.main {
  padding: 45px 50px;
}
.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.map-holder {
  width: 65%;
}
#map {
  height: 70vh;
}
.dislpay-arena {
  background: #ffffff;
  box-shadow: 0px -3px 10px rgba(0, 58, 78, 0.1);
  border-radius: 5px;
  padding: 20px 30px;
  width: 25%;
}
.coordinates-header {
  margin-bottom: 50px;
}
.coordinates-header h3 {
  color: #1f2a53;
  font-weight: 600;
}
.coordinates-header p {
  color: rgba(13, 16, 27, 0.75);
  font-weight: 600;
  font-size: 0.875rem;
}
.form-group {
  position: relative;
}
#bb{
  background-color: #3cbba6;
    /* border: 2px solid #03e1bc; */
    color: #edf1f5;
    padding: 5px 6px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
    /* margin: 10px 30px; */
    cursor: pointer;
    border-radius: 50px;
}
.location-control {
  height: 30px;
  background: #ffffff;
  border: 1px solid rgba(31, 42, 83, 0.25);
  box-shadow: 0px 0px 10px rgba(73, 165, 198, 0.1);
  border-radius: 4px;
  padding: 0px 10px;
  width: 90%;
}
.location-control:focus {
  outline: none;
}
.location-btn {
  margin-top: 15px;
  padding: 10px 15px;
  background: #d80739;
  box-shadow: 0px 4px 10px rgba(73, 165, 198, 0.1);
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 600;
}
.location-btn:focus {
  outline: none;
}
.disabled {
  background: #db7990;
  cursor: not-allowed;
}
.copy-btn {
  background: #f4f6f8 0% 0% no-repeat padding-box;
  border: 1px solid #f4f6f8;
  border-radius: 0px 3px 3px 0px;
  position: absolute;
  color: #5171ef;
  font-size: 0.875rem;
  font-weight: 500;
  height: 30px;
  padding: 0px 10px;
  cursor: pointer;
  right: 3.5%;
  top: 5%;
}
.copy-btn:focus {
  outline: none;
}
.dislpay-arena[data-v-0d798840] {
  width: 30%;
}
.coordinates-header h3[data-v-0d798840] {
  font-size: 20px;
}
</style>
